import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Layout components
import MainLayout from './components/layout/MainLayout';
import AuthLayout from './components/layout/AuthLayout';

// Pages (will be created)
import Landing from './pages/Landing';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Dashboard from './pages/Dashboard';
import ExecutiveDashboard from './pages/ExecutiveDashboard';
import FinancialModeling from './pages/FinancialModeling';
import ProfitLoss from './pages/ProfitLoss';
import CashFlow from './pages/CashFlow';
import BalanceSheet from './pages/BalanceSheet';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Integrations from './pages/Integrations';
import OrganizationalHierarchy from './pages/OrganizationalHierarchy';
import SegmentReporting from './pages/SegmentReporting';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import ScheduleDemo from './pages/ScheduleDemo';

// Hooks
import { useAuthStore } from './stores/authStore';

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <>
      <Routes>
        {/* Root path - Always show Landing page */}
        <Route path="/" element={<Landing />} />
        
        {/* Landing page route (also accessible) */}
        <Route path="/landing" element={<Landing />} />

        {/* Public routes - Auth pages */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<div>Forgot Password</div>} />
        </Route>

        {/* Public routes - Legal pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/schedule-demo" element={<ScheduleDemo />} />

        {/* Protected routes - only accessible when authenticated */}
        {isAuthenticated && (
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/executive" element={<ExecutiveDashboard />} />
            <Route path="/modeling" element={<FinancialModeling />} />
            <Route path="/profit-loss" element={<ProfitLoss />} />
            <Route path="/cash-flow" element={<CashFlow />} />
            <Route path="/balance-sheet" element={<BalanceSheet />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/integrations" element={<Integrations />} />
            <Route path="/hierarchy" element={<OrganizationalHierarchy />} />
            <Route path="/segments" element={<SegmentReporting />} />
          </Route>
        )}

        {/* Catch-all route - redirect to landing page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Global toast notifications */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#FFFFFF',
            color: '#1F2937',
            border: '1px solid #E5E7EB',
          },
          success: {
            iconTheme: {
              primary: '#1B998B',
              secondary: '#FFFFFF',
            },
          },
          error: {
            iconTheme: {
              primary: '#FF6B35',
              secondary: '#FFFFFF',
            },
          },
        }}
      />
    </>
  );
}

export default App;
